import React, { useEffect, useState, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { findIndex, filter, truncate } from 'lodash';
import { useSwipeable } from 'react-swipeable';
import moment from 'moment';
import AddToHomescreen from 'react-add-to-homescreen';

import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import IconButton from '@material-ui/core/IconButton';
import InfoIcon from '@material-ui/icons/Info';
import AddBoxOutlinedIcon from '@material-ui/icons/AddBoxOutlined';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import AddToHomeScreenIcon from '@material-ui/icons/AddToHomeScreen';
import SvgIcon from '@material-ui/core/SvgIcon';

import AboutCard from '../../components/Card/AboutCard';
import StampCard from '../../components/Card/StampCard';
import EmptyStampCard from '../../components/Card/EmptyStampCard';
import RewardCard from '../../components/Card/RewardCard';
import RedeemedRewardCard from '../../components/Card/RedeemedRewardCard';
import ReferralCard from '../../components/Card/ReferralCard';
import StoreCard from '../../components/Card/StoreCard';
import useNavContext from '../../hooks/useNavContext';
import useDeepLinkContext from '../../hooks/useDeepLinkContext';
import useStampCardContext from '../../hooks/useStampCardContext';
import { ReactComponent as ShareIcon } from '../../assets/icons/Share.svg';

import * as MerchantService from '../../api/merchantService';
import * as LoyaltyRewardService from '../../api/loyaltyRewardsService';
import * as StampCardService from '../../api/stampCardService';
import * as StampCampaignService from '../../api/stampCampaignService';
import * as RewardCardService from '../../api/rewardCardService';
import * as ReferralService from '../../api/referralService';
import * as StoreService from '../../api/storeService';
import * as ProfileService from '../../api/profileService';
import * as SurveyService from '../../api/surveyService';
import AddStampDialog from '../../components/Dialogs/AddStampDialog';
import AddStampSuccessDialog from '../../components/Dialogs/AddStampSuccessDialog';
import EditProfileDialog from '../../components/Dialogs/EditProfileDialog';
import DeleteCardDialog from '../../components/Dialogs/DeleteCardDialog';
import SelectMerchantStoreDialog from '../../components/Dialogs/SelectMerchantStoreDialog';
import RewardRedemptionDialog from '../../components/Dialogs/RewardRedemptionDialog';
import RewardSuccessRedemptionDialog from '../../components/Dialogs/RewardSuccessRedemptionDialog';
import RewardUnlockSuccessDialog from '../../components/Dialogs/RewardUnlockSuccessDialog';
import StoreLocationDialog from '../../components/Dialogs/StoreLocationDialog';
import SurveyDialog from '../../components/Dialogs/SurveyDialog';
import Spinner from '../../components/Spinner';
import VisitedStoresCard from '../../components/Card/VisitedStoresCard';

interface RouteParams {
  merchantId: string;
  stampCardId: string;
}

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  grow: {
    flexGrow: 1,
  },
  rewardTitle: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },
  subText: {
    color: '#989AA2',
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  stampContainer: {
    marginTop: 8,
  },
  boxContainer: {
    flex: 1,
    marginTop: 350,
  },
  refreshContainer: {
    flex: 1,
    width: 450,
    height: 600,
    marginTop: 120,
  },
  showHistoryBox: {
    marginTop: -55,
    position: 'relative',
    right: -140,
  },
  showDetailButton: {
    color: theme.palette.text.secondary,
    padding: 5,
  },
  activeCardContainer: {
    marginTop: theme.spacing(9),
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    width: '100%',
  },
  otherCard: {
    color: theme.palette.common.black,
  },
  singleStampContainer: {
    marginTop: theme.spacing(9),
  },
  indicatorContainer: {
    marginTop: theme.spacing(),
  },
  dialogTextContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  icon: {
    marginLeft: theme.spacing(),
  },
}));

/**
 * Merchant
 */
export default function MerchantScreen() {
  const { merchantId } = useParams<RouteParams>();
  const classes = useStyles();
  const [merchant, setMerchant] = useState<MerchantService.Merchant | null>(
    null
  );
  const [isLoading, setIsLoading] = useState(true);
  const [stampCard, setStampCard] = useState<StampCardService.StampCard | null>(
    null
  );
  const [milestones, setMilestones] = useState<
    LoyaltyRewardService.RedemptionMilestone[]
  >([]);
  const [rewardCardList, setRewardCardList] = useState<
    RewardCardService.RewardCard[]
  >([]);
  const [profile, setProfile] = useState<ProfileService.Profile | null>(null);
  const [storeList, setStoreList] = useState<StoreService.Store[]>([]);
  const [stampCampaign, setStampCampaign] =
    useState<StampCampaignService.StampCampaign | null>(null);
  const [launchEditProfileDialog, setLaunchEditProfileDialog] = useState(false);
  const [launchAddStampDialog, setLaunchAddStampDialog] = useState(false);
  const [launchDeleteStampDialog, setLaunchDeleteStampDialog] = useState(false);
  const [storeMerchantDialog, setStoreMerchantDialog] = useState(false);
  const [rewardRedemptionDialog, setRewardRedemptionDialog] = useState(false);
  const [successRedemptionDialog, setSuccessRedemptionDialog] = useState(false);
  const [successUnlockedDialog, setSuccessUnlockedDialog] = useState(false);
  const [successStampDialog, setSuccessStampDialog] = useState(false);
  const [storeDialog, setStoreDialog] = useState(false);
  const [redeemedRewardCardList, setRedeemedRewardCardList] = useState<
    RewardCardService.RewardCard[]
  >([]);
  const [selectedRedeemRewardCardId, setSelectedRedeemRewardCardId] =
    useState('');
  const [selectedUnlockRewardCardId, setSelectedUnlockRewardCardId] =
    useState('');
  const [selectedStorePINId, setSelectedStorePINId] = useState('');
  const [selectedReward, setSelectedReward] =
    useState<RewardCardService.RewardCard | null>(null);
  const [referral, setReferral] =
    useState<ReferralService.ReferralProgram | null>(null);
  const [referralLink, setReferralLink] =
    useState<ReferralService.Deeplink | null>(null);
  const [addedStamp, setAddedStamp] = useState(1);
  const [reqFullName, setReqFullName] = useState(false);
  const [reqEmail, setReqEmail] = useState(false);
  const [reqAltEmail, setReqAltEmail] = useState(false);
  const [reqMobNum, setReqMobNum] = useState(false);
  const [reqDOB, setReqDOB] = useState(false);
  const [reqCompany, setReqCompany] = useState(false);
  const [historyExpand, setHistoryExpand] = useState(false);
  const [activeStampCardList, setActiveStampCardList] = useState<
    StampCardService.StampCard[]
  >([]);
  const [selectedStampCardId, setSelectedStampCardId] = useState('');
  const [selectedSlotNum, setSelectedSlotNum] = useState(0);
  const [selectedStampCampaignId, setSelectedStampCampaignId] = useState('');
  const [selectedStampCardIndex, setSelectedStampCardIndex] = useState<
    number[]
  >([]);
  const [refreshStampCard, setRefreshStampCard] = useState(false);
  const [selectedDeleteStampCardIndex, setSelectedDeleteStampCardIndex] =
    useState(0);
  const [milestoneThresholdList, setMilestoneThresholdList] = useState<
    number[]
  >([]);
  const [addToHomeScreenDialogOpen, setAddToHomeScreenDialogOpen] =
    useState(false);
  const [device, setDevice] = useState('');
  const [selectedSurvey, setSelectedSurvey] =
    useState<SurveyService.Survey | null>(null);
  const [openSurveyDialog, setOpenSurveyDialog] = useState(false);
  const [selectedStoreId, setSelectedStoreId] = useState<string | undefined>(
    undefined
  );
  const [visitedStores, setVisitedStores] =
    useState<StampCardService.StoreVisitList | null>(null);

  const nav = useNavContext();
  const dl = useDeepLinkContext();
  const sc = useStampCardContext();
  dl?.removeDeeplink();

  const detectDevice = () => {
    const userAgent = navigator.userAgent || navigator.vendor;

    // Check for iOS
    if (/iPad|iPhone|iPod/.test(userAgent)) {
      return 'iOS Device';
    }

    // Check for Android
    if (/android/i.test(userAgent)) {
      return 'Android Device';
    }

    // Default to unknown
    return 'Unknown Device';
  };

  useEffect(() => {
    if (sc && sc.stampcard && sc.stampcard.selectedStampCardId) {
      setSelectedStampCardId(sc.stampcard.selectedStampCardId);
      setSelectedSlotNum(sc.stampcard.selectedSlotNumber);
      setSelectedStampCampaignId(sc.stampcard.selectedStampCampaignId);
    }
  }, [sc]);

  useEffect(() => {
    const fetch = async () => {
      if (selectedStampCardId.length > 0) {
        const res = await StampCardService.trackStoresVisited(
          merchantId,
          selectedStampCardId
        );
        setVisitedStores(res);
      }
    };

    if (selectedStampCardId.length > 0) {
      fetch();
    }
  }, [selectedStampCardId, merchantId]);

  const fetchRewardCard = useCallback(async () => {
    try {
      const rewardCards = await RewardCardService.listMerchantRewardCards(
        merchantId
      );

      if (rewardCards && rewardCards.length > 0) {
        const now = parseInt(moment().format('X'), 10);

        const redeemedRewardCards = filter(rewardCards, function (card) {
          return card.status === 'redeemed';
        });

        const collectedRewardCards = filter(rewardCards, function (card) {
          return card.status === 'collected' && card.expiresAt >= now;
        });

        const expiredRewardCards = filter(rewardCards, function (card) {
          return card.status === 'expired';
        });

        if (collectedRewardCards) {
          setRewardCardList(collectedRewardCards);
        }

        if (expiredRewardCards) {
          setRedeemedRewardCardList(
            redeemedRewardCards.concat(
              expiredRewardCards.concat(
                filter(collectedRewardCards, function (card) {
                  return card.expiresAt < now;
                })
              )
            )
          );
        } else {
          redeemedRewardCards.concat(
            filter(collectedRewardCards, function (card) {
              return card.expiresAt < now;
            })
          );
        }
        setTimeout(() => setIsLoading(false), 1000);
      }
    } catch (e) {
      console.log('error: ', e);
      setTimeout(() => setIsLoading(false), 1000);
    }
  }, [merchantId]);

  useEffect(() => {
    const fetch = async () => {
      if (selectedStampCardId.length > 0) {
        const resProfile = await ProfileService.get();
        setProfile(resProfile);

        const res = await MerchantService.get(merchantId);
        setMerchant(res);

        const resStamp = await StampCardService.get(selectedStampCardId);

        if (resStamp) {
          // if selectedStampCard is completed, try get the latest stamp card
          // if (resStamp.status === 'completed') {
          //   try {
          //     const resNewStamp =
          //       await StampCardService.getStampCardByCampaignAndSlot(
          //         selectedStampCampaignId,
          //         selectedSlotNum
          //       );

          //     if (resNewStamp) {
          //       setStampCard(resNewStamp);
          //       if (sc) {
          //         sc.setStampCard({
          //           selectedStampCardId: resNewStamp.id,
          //           selectedSlotNumber: resNewStamp.slotNumber,
          //           selectedStampCampaignId: resNewStamp.loyalty_campaign.id,
          //         });
          //       }
          //     }
          //   } catch (e) {
          //     setStampCard(resStamp);
          //   }
          // } else {
          setStampCard(resStamp);
          // }

          if (resStamp && resStamp.stampCampaignType === 'PASSPORT') {
            const resTrackStoreList = await StampCardService.trackStoresVisited(
              merchantId,
              resStamp.id
            );

            if (resTrackStoreList) {
              console.log('resTrackStoreList: ', resTrackStoreList);
              setVisitedStores(resTrackStoreList);
            }
          }
        }

        const resActiveStampCardList = await StampCardService.listByMerchantId(
          merchantId
        );
        if (resActiveStampCardList) {
          if (resActiveStampCardList && resActiveStampCardList.length > 0) {
            let sStampCardIndex = findIndex(
              resActiveStampCardList,
              function (card) {
                return card.id === selectedStampCardId;
              }
            );
            if (sStampCardIndex > -1) {
              if (sStampCardIndex === 0) {
                setSelectedStampCardIndex([0, 1]);
              } else {
                if (sStampCardIndex === resActiveStampCardList.length - 1) {
                  setSelectedStampCardIndex([
                    sStampCardIndex - 1,
                    sStampCardIndex,
                  ]);
                } else {
                  setSelectedStampCardIndex([
                    sStampCardIndex,
                    sStampCardIndex + 1,
                  ]);
                }
              }
            }

            setActiveStampCardList(resActiveStampCardList);
          }
        }

        const resMilestone = await LoyaltyRewardService.listMilestone(
          selectedStampCampaignId
        );
        setMilestones(resMilestone);
        if (resMilestone.length > 0) {
          setMilestoneThresholdList(resMilestone.map((m) => m.threshold));
        }

        const resCampaign = await StampCampaignService.get(
          selectedStampCampaignId
        );
        setStampCampaign(resCampaign);

        const resStore = await StoreService.list(merchantId);
        setStoreList(resStore);

        setTimeout(() => fetchRewardCard(), 1000);
      } else {
        const resProfile = await ProfileService.get();
        setProfile(resProfile);

        const res = await MerchantService.get(merchantId);
        setMerchant(res);

        const resStore = await StoreService.list(merchantId);
        setStoreList(resStore);

        setTimeout(() => fetchRewardCard(), 1000);
      }
    };

    if (isLoading) {
      setDevice(detectDevice);
      fetch();
    }
    if (nav) {
      nav.removeNav();
    }
  }, [
    merchantId,
    isLoading,
    nav,
    fetchRewardCard,
    selectedStampCardId,
    sc,
    selectedSlotNum,
    selectedStampCampaignId,
  ]);

  useEffect(() => {
    const fetch = async () => {
      if (selectedStampCardId.length > 0) {
        const resStamp = await StampCardService.get(selectedStampCardId);
        if (resStamp) {
          // if selectedStampCard is completed, try get the latest stamp card
          // if (resStamp.status === 'completed') {
          //   try {
          //     const resNewStamp =
          //       await StampCardService.getStampCardByCampaignAndSlot(
          //         selectedStampCampaignId,
          //         selectedSlotNum
          //       );

          //     if (resNewStamp) {
          //       setStampCard(resNewStamp);
          //       if (sc) {
          //         sc.setStampCard({
          //           selectedStampCardId: resNewStamp.id,
          //           selectedSlotNumber: resNewStamp.slotNumber,
          //           selectedStampCampaignId: resNewStamp.loyalty_campaign.id,
          //         });
          //       }
          //     }
          //   } catch (e) {
          //     setStampCard(resStamp);
          //   }
          // } else {
          setStampCard(resStamp);
          // }
          if (resStamp && resStamp.stampCampaignType === 'PASSPORT') {
            const resTrackStoreList = await StampCardService.trackStoresVisited(
              merchantId,
              resStamp.id
            );

            if (resTrackStoreList) {
              console.log('resTrackStoreList: ', resTrackStoreList);
              setVisitedStores(resTrackStoreList);
            }
          }
        }

        const resActiveStampCardList = await StampCardService.listByMerchantId(
          merchantId
        );

        if (resActiveStampCardList && resActiveStampCardList.length > 0) {
          setActiveStampCardList(resActiveStampCardList);
        }

        const resMilestone = await LoyaltyRewardService.listMilestone(
          resStamp.loyalty_campaign.id
        );
        setMilestones(resMilestone);

        const resCampaign = await StampCampaignService.get(
          resStamp.loyalty_campaign.id
        );
        setStampCampaign(resCampaign);

        fetchRewardCard();

        setRefreshStampCard(false);
      } else {
        setActiveStampCardList([]);
        setStampCampaign(null);
        fetchRewardCard();
        setRefreshStampCard(false);
      }
    };

    if (refreshStampCard) {
      fetch();
    }
  }, [
    refreshStampCard,
    selectedStampCardId,
    merchantId,
    sc,
    selectedSlotNum,
    selectedStampCampaignId,
    fetchRewardCard,
  ]);

  useEffect(() => {
    const fetchRedeemedRewardCard = async () => {
      const res = await RewardCardService.get(selectedRedeemRewardCardId);

      setSelectedReward(res);
    };

    if (selectedRedeemRewardCardId) {
      fetchRedeemedRewardCard();
    }
  }, [selectedRedeemRewardCardId]);

  // Check if user profile is incomplete and merchant require some info
  useEffect(() => {
    if (merchant && profile) {
      if (!profile.profileCompletedStatus) {
        if (merchant.requiredUserInfo.FullName) {
          setReqFullName(true);
        }
        if (merchant.requiredUserInfo.Email) {
          setReqEmail(true);
        }
        if (
          merchant.requiredUserInfo.AltEmail &&
          profile.email.length > 0 &&
          profile.email.includes('@privaterelay.appleid.com')
        ) {
          setReqAltEmail(true);
        }
        if (merchant.requiredUserInfo.MobNum && profile.email.length > 0) {
          setReqMobNum(true);
        }
        if (merchant.requiredUserInfo.DOB) {
          setReqDOB(true);
        }
        if (merchant.requiredUserInfo.Company) {
          setReqCompany(true);
        }
        if (
          merchant.requiredUserInfo.FullName &&
          profile.firstName.length === 0 &&
          profile.lastName.length === 0
        ) {
          setLaunchEditProfileDialog(false);
          setTimeout(() => setIsLoading(false), 1000);
        } else {
          setLaunchEditProfileDialog(true);
          setTimeout(() => setIsLoading(false), 1000);
        }
      } else {
        setIsLoading(true);
        if (
          merchant.requiredUserInfo.FullName &&
          profile.profileCompletedStatus.FullName === false
        ) {
          setReqFullName(true);
        }
        if (
          merchant.requiredUserInfo.Email &&
          profile.profileCompletedStatus.Email === false &&
          profile.mobNum.length > 0
        ) {
          setReqEmail(true);
        }
        if (
          merchant.requiredUserInfo.AltEmail &&
          profile.profileCompletedStatus.AltEmail === false &&
          profile.email.length > 0 &&
          profile.email.includes('@privaterelay.appleid.com')
        ) {
          setReqAltEmail(true);
        }
        if (
          merchant.requiredUserInfo.MobNum &&
          profile.profileCompletedStatus.MobNum === false &&
          profile.email.length > 0
        ) {
          setReqMobNum(true);
        }
        if (
          merchant.requiredUserInfo.DOB &&
          profile.profileCompletedStatus.DOB === false
        ) {
          setReqDOB(true);
        }
        if (
          merchant.requiredUserInfo.Company &&
          profile.profileCompletedStatus.Company === false
        ) {
          setReqCompany(true);
        }
        if (
          (merchant.requiredUserInfo.Email &&
            profile.profileCompletedStatus.Email === false &&
            profile.mobNum.length > 0) ||
          (merchant.requiredUserInfo.AltEmail &&
            profile.profileCompletedStatus.AltEmail === false &&
            profile.email.length > 0 &&
            profile.email.includes('@privaterelay.appleid.com')) ||
          (merchant.requiredUserInfo.MobNum &&
            profile.profileCompletedStatus.MobNum === false &&
            profile.email.length > 0) ||
          (merchant.requiredUserInfo.DOB &&
            profile.profileCompletedStatus.DOB === false) ||
          (merchant.requiredUserInfo.Company &&
            profile.profileCompletedStatus.Company === false)
        ) {
          if (
            merchant.requiredUserInfo.FullName &&
            profile.firstName.length === 0 &&
            profile.lastName.length === 0
          ) {
            setLaunchEditProfileDialog(false);
            setTimeout(() => setIsLoading(false), 1000);
          } else {
            setLaunchEditProfileDialog(true);
            setTimeout(() => setIsLoading(false), 1000);
          }
        } else {
          setTimeout(() => setIsLoading(false), 1000);
        }
      }
    }
  }, [
    merchant,
    profile,
    reqFullName,
    reqAltEmail,
    reqEmail,
    reqDOB,
    reqMobNum,
    reqCompany,
  ]);

  useEffect(() => {
    const fetchReferral = async () => {
      try {
        const res = await ReferralService.get(merchantId);

        if (res) {
          setReferral(res);
        }
      } catch (e) {
        console.log('Error: ', e);
      }
    };

    if (merchantId) {
      fetchReferral();
    }
  }, [merchantId]);

  useEffect(() => {
    const fetchReferralLink = async () => {
      try {
        const res = await ReferralService.getDeepLink(merchantId);

        if (res) {
          setReferralLink(res);
        }
      } catch (e) {
        console.log('Error: ', e);
      }
    };

    if (merchantId) {
      fetchReferralLink();
    }
  }, [merchantId]);

  const handleAddStamp = () => {
    setLaunchAddStampDialog(true);
  };

  const handleDeleteStamp = async () => {
    try {
      await StampCardService.archiveStampCard(selectedStampCardId);
      if (activeStampCardList.length === 1) {
        setSelectedStampCardId('');
        setRefreshStampCard(true);
      } else {
        if (selectedDeleteStampCardIndex === activeStampCardList.length - 1) {
          setSelectedStampCardId(
            activeStampCardList[selectedDeleteStampCardIndex - 1].id
          );
        } else {
          setSelectedStampCardId(
            activeStampCardList[selectedDeleteStampCardIndex + 1].id
          );
        }
        setRefreshStampCard(true);
      }
    } catch (e) {
      console.log('Error:', e);
      setLaunchDeleteStampDialog(true);
    }
  };

  const setRedeemReward = (rewardCardId: string, storeId?: string) => {
    setSelectedStoreId(storeId ? storeId : undefined);
    setSelectedRedeemRewardCardId(rewardCardId);
    setStoreMerchantDialog(true);
  };

  const unlockedReward = async (surveyId: string, rewardCardId: string) => {
    setSelectedUnlockRewardCardId(rewardCardId);
    if (merchant) {
      try {
        const res = await SurveyService.get(merchant.id, surveyId);

        setSelectedSurvey(res);
        setOpenSurveyDialog(true);
      } catch (e) {
        console.log('Error:', e);
      }
    }
  };

  const handleRedeemReward = async () => {
    try {
      const res = await RewardCardService.redeem(
        selectedRedeemRewardCardId,
        selectedStorePINId
      );
      if (res) {
        setRewardRedemptionDialog(false);
        setSuccessRedemptionDialog(true);
      }
    } catch (e) {
      console.log('error: e');
      setRewardRedemptionDialog(false);
    }
  };

  const handleNavLeft = () => {
    if (
      selectedStampCardIndex.length > 0 &&
      selectedStampCardIndex.length === 2
    ) {
      console.log(
        'before left selectedStampCardIndex: ',
        selectedStampCardIndex
      );
      setSelectedStampCardIndex([
        selectedStampCardIndex[0] - 1,
        selectedStampCardIndex[1] - 1,
      ]);
      console.log('after left selectedStampCardIndex: ', [
        selectedStampCardIndex[0] - 1,
        selectedStampCardIndex[1] - 1,
      ]);
    }
  };

  const handleNavRight = () => {
    if (
      selectedStampCardIndex.length > 0 &&
      selectedStampCardIndex.length === 2
    ) {
      console.log(
        'before right selectedStampCardIndex: ',
        selectedStampCardIndex
      );
      setSelectedStampCardIndex([
        selectedStampCardIndex[0] + 1,
        selectedStampCardIndex[1] + 1,
      ]);
      console.log('after right selectedStampCardIndex: ', [
        selectedStampCardIndex[0] + 1,
        selectedStampCardIndex[1] + 1,
      ]);
    }
  };

  const handleCheckForNewStampCard = async () => {
    if (stampCampaign) {
      try {
        const res = await StampCardService.getStampCardByCampaignAndSlot(
          stampCampaign.id,
          stampCampaign.slotNumber
        );
        if (res && sc) {
          sc.setStampCard({
            selectedStampCardId: res.id,
            selectedSlotNumber: res.slotNumber,
            selectedStampCampaignId: res.loyalty_campaign.id,
          });
          setSelectedStampCardId(res.id);
          setRefreshStampCard(true);
        }
      } catch (e) {
        console.log('Error:', e);
        setRefreshStampCard(true);
      }
    }
  };

  const handlerSwipe = useSwipeable({
    swipeDuration: 500,
    preventScrollOnSwipe: true,
    trackMouse: true,
    onSwipedLeft: (eventData) => {
      let selIndex = findIndex(activeStampCardList, function (card) {
        return card.id === selectedStampCardId;
      });
      if (selIndex <= activeStampCardList.length - 1) {
        if (!selectedStampCardIndex.includes(activeStampCardList.length - 1)) {
          handleNavRight();
        }
        setSelectedStampCardId(activeStampCardList[selIndex + 1].id);
        setRefreshStampCard(true);
      }
    },
    onSwipedRight: (eventData) => {
      let selIndex = findIndex(activeStampCardList, function (card) {
        return card.id === selectedStampCardId;
      });

      if (selIndex >= 0) {
        if (!selectedStampCardIndex.includes(0)) {
          handleNavLeft();
        }
        setSelectedStampCardId(activeStampCardList[selIndex - 1].id);
        setRefreshStampCard(true);
      }
    },
  });

  return (
    <>
      <div className={classes.container}>
        {isLoading && (
          <div className={classes.boxContainer}>
            <Box display="flex" justifyContent="center">
              <Spinner />
            </Box>
          </div>
        )}
        {!isLoading && merchant && storeList.length > 0 && (
          <>
            {activeStampCardList.length === 0 && (
              <div className={classes.singleStampContainer}>
                <EmptyStampCard
                  merchantName={merchant.name}
                  merchantCoverImage={merchant.cover?.versions.xl}
                  merchantLogo={merchant.logo?.versions.xl}
                />
              </div>
            )}
            {activeStampCardList.length === 1 && (
              <div className={classes.singleStampContainer}>
                <StampCard
                  stampCardId={activeStampCardList[0].id}
                  merchantId={merchant.id}
                  merchantName={merchant.name}
                  merchantCoverImage={merchant.cover?.versions.xl}
                  merchantLogo={merchant.logo?.versions.xl}
                  milestones={milestones}
                  maxStamps={activeStampCardList[0].redemptionCost}
                  quantity={activeStampCardList[0].quantity}
                  handleAddStamp={handleAddStamp}
                  stampCardStatus={activeStampCardList[0].status}
                  handleDeleteCard={() => {
                    setSelectedDeleteStampCardIndex(-1);
                    setLaunchDeleteStampDialog(true);
                  }}
                  campaignType={activeStampCardList[0].stampCampaignType}
                />
              </div>
            )}
            {activeStampCardList.length > 1 && (
              <>
                <div className={classes.activeCardContainer}>
                  <IconButton
                    color="primary"
                    onClick={() => handleNavLeft()}
                    disabled={selectedStampCardIndex.includes(0)}
                  >
                    <ChevronLeftIcon />
                  </IconButton>
                  {activeStampCardList.length > 0 &&
                    activeStampCardList.map((card, index) => {
                      return (
                        <>
                          {card.status !== 'archived' &&
                            card.id === selectedStampCardId &&
                            selectedStampCardIndex.includes(index) && (
                              <Button
                                variant="text"
                                color="primary"
                                onClick={() => null}
                              >
                                {truncate(card.stampCampaignName, {
                                  length: 20,
                                })}
                              </Button>
                            )}
                          {selectedStampCardIndex.includes(index) &&
                            card.id !== selectedStampCardId && (
                              <Button
                                variant="text"
                                className={classes.otherCard}
                                onClick={() => {
                                  if (sc) {
                                    console.log('Selected Index: ', index);
                                    console.log(
                                      'selectedStampCardIndex: ',
                                      selectedStampCardIndex
                                    );

                                    sc.setStampCard({
                                      selectedStampCardId: card.id,
                                      selectedSlotNumber: card.slotNumber,
                                      selectedStampCampaignId:
                                        card.loyalty_campaign.id,
                                    });

                                    setSelectedStampCardId(card.id);

                                    setRefreshStampCard(true);
                                  }
                                }}
                              >
                                {truncate(card.stampCampaignName, {
                                  length: 20,
                                })}
                              </Button>
                            )}
                        </>
                      );
                    })}
                  <IconButton
                    color="primary"
                    onClick={() => handleNavRight()}
                    disabled={selectedStampCardIndex.includes(
                      activeStampCardList.length - 1
                    )}
                  >
                    <ChevronRightIcon />
                  </IconButton>
                </div>
                {activeStampCardList.length > 1 && (
                  <>
                    <div {...handlerSwipe}>
                      {activeStampCardList.map((card, idx) => {
                        return (
                          <div
                            className={classes.stampContainer}
                            key={idx}
                            hidden={card.id !== selectedStampCardId}
                          >
                            <StampCard
                              key={idx}
                              stampCardId={card.id}
                              merchantId={merchant.id}
                              merchantName={merchant.name}
                              merchantCoverImage={merchant.cover?.versions.xl}
                              merchantLogo={merchant.logo?.versions.xl}
                              milestones={milestones}
                              maxStamps={card.redemptionCost}
                              quantity={card.quantity}
                              handleAddStamp={handleAddStamp}
                              stampCardStatus={card.status}
                              handleDeleteCard={() => {
                                setSelectedDeleteStampCardIndex(idx);
                                setLaunchDeleteStampDialog(true);
                              }}
                              campaignType={card.stampCampaignType}
                            />
                          </div>
                        );
                      })}
                    </div>
                    <div className={classes.indicatorContainer}>
                      {activeStampCardList.map((card, idx) => {
                        return (
                          <FiberManualRecordIcon
                            fontSize="small"
                            color={
                              card.id === selectedStampCardId
                                ? 'primary'
                                : 'disabled'
                            }
                            className={classes.indicatorContainer}
                          />
                        );
                      })}
                    </div>
                  </>
                )}
              </>
            )}
            <Typography variant="h4" className={classes.rewardTitle}>
              Your Rewards
            </Typography>
            {rewardCardList.length > 0 ? (
              <RewardCard
                rewardCardList={rewardCardList}
                handleRedeemReward={setRedeemReward}
                handleLockedReward={unlockedReward}
              />
            ) : (
              <Typography variant="h6" className={classes.subText} gutterBottom>
                Earned rewards will appear here
              </Typography>
            )}

            {stampCard &&
              stampCard.stampCampaignType === 'PASSPORT' &&
              stampCard.showVisitedStores &&
              visitedStores && (
                <>
                  <Typography variant="h4" className={classes.rewardTitle}>
                    Visited
                  </Typography>
                  <VisitedStoresCard storeVisitedList={visitedStores} />
                </>
              )}

            {referral && referralLink && (
              <>
                <Typography variant="h4" className={classes.rewardTitle}>
                  Refer a Friend
                </Typography>
                <ReferralCard
                  merchantId={merchantId}
                  merchantName={merchant.name}
                  joiningRewardId={referral.joiningReward.id}
                  referralRewardId={referral.referralReward.id}
                  handleCopyLink={() => console.log('handle copy link')}
                  link={referralLink.link}
                />
              </>
            )}
            {storeList.length > 0 && (
              <>
                <Typography variant="h4" className={classes.rewardTitle}>
                  Location{storeList.length > 1 ? 's' : ''}
                </Typography>
                <StoreCard
                  storeList={storeList}
                  handleDialog={() => setStoreDialog(true)}
                />
              </>
            )}
            <Typography variant="h4" className={classes.rewardTitle}>
              About
            </Typography>
            <AboutCard about={merchant.about} link={merchant.url} />
            <Typography variant="h4" className={classes.rewardTitle}>
              History
            </Typography>
            {redeemedRewardCardList.length > 0 &&
              redeemedRewardCardList.length <= 3 && (
                <RedeemedRewardCard rewardCardList={redeemedRewardCardList} />
              )}
            {redeemedRewardCardList.length === 0 && (
              <Typography variant="h6" className={classes.subText} gutterBottom>
                Redeemed and expired rewards will appear here
              </Typography>
            )}
            {redeemedRewardCardList.length > 3 && (
              <>
                <div className={classes.showHistoryBox}>
                  <Button
                    variant="text"
                    onClick={() => setHistoryExpand(!historyExpand)}
                    className={classes.showDetailButton}
                  >
                    {historyExpand ? 'Hide' : 'Show All'}
                  </Button>
                </div>
                {!historyExpand && (
                  <RedeemedRewardCard
                    rewardCardList={redeemedRewardCardList.slice(0, 3)}
                  />
                )}
                {historyExpand && (
                  <RedeemedRewardCard rewardCardList={redeemedRewardCardList} />
                )}
              </>
            )}
            {storeList && (
              <StoreLocationDialog
                storeList={storeList}
                open={storeDialog}
                onClose={() => setStoreDialog(false)}
              />
            )}
            {launchDeleteStampDialog && stampCard && (
              <DeleteCardDialog
                stampCardName={stampCard.stampCampaignName}
                open={launchDeleteStampDialog}
                onClose={() => setLaunchDeleteStampDialog(false)}
                onCancel={() => setLaunchDeleteStampDialog(false)}
                confirmDelete={() => {
                  setLaunchDeleteStampDialog(false);
                  handleDeleteStamp();
                }}
              />
            )}
            {launchAddStampDialog && stampCard && (
              <AddStampDialog
                stampCardId={stampCard.id}
                open={launchAddStampDialog}
                onClose={() => setLaunchAddStampDialog(false)}
                confirmRedeem={(addedStamp: number) => {
                  setAddedStamp(addedStamp);
                  setLaunchAddStampDialog(false);
                  setSuccessStampDialog(true);
                }}
              />
            )}
            {successStampDialog && stampCard && (
              <AddStampSuccessDialog
                open={successStampDialog}
                onClose={() => {
                  handleCheckForNewStampCard();
                  setSuccessStampDialog(false);
                }}
                isMilestone={
                  milestoneThresholdList.length > 0
                    ? milestoneThresholdList.includes(
                        stampCard.quantity + addedStamp
                      )
                    : false
                }
                isComplete={
                  stampCard.quantity + addedStamp === stampCard.redemptionCost
                }
                campaignId={stampCard.loyalty_campaign.id}
                quantity={stampCard.quantity}
                isMultipleStamp={addedStamp > 1}
                stampAdded={addedStamp.toString()}
                handleAddMoreStamp={() => {
                  handleCheckForNewStampCard();
                  setSuccessStampDialog(false);
                  setLaunchAddStampDialog(true);
                }}
                allowAddMoreStamp={false}
              />
            )}
            {storeMerchantDialog && (
              <SelectMerchantStoreDialog
                open={storeMerchantDialog}
                onClose={() => {
                  setSelectedStoreId(undefined);
                  setStoreMerchantDialog(false);
                }}
                merchantId={merchantId}
                merchantLogo={merchant.logo?.versions.xl}
                preferredStoreId={selectedStoreId}
                confirmStore={(storePINId: string) => {
                  setSelectedStoreId(undefined);
                  setSelectedStorePINId(storePINId);
                  setStoreMerchantDialog(false);
                  setRewardRedemptionDialog(true);
                }}
              />
            )}
            <RewardRedemptionDialog
              merchantLogo={merchant.logo?.versions.xl}
              open={rewardRedemptionDialog}
              onClose={() => setRewardRedemptionDialog(false)}
              rewardTitle={selectedReward ? selectedReward.title : ''}
              confirmRedemption={() => {
                handleRedeemReward();
              }}
            />
            <RewardSuccessRedemptionDialog
              rewardTitle={selectedReward ? selectedReward.title : ''}
              open={successRedemptionDialog}
              onClose={() => {
                setSuccessRedemptionDialog(false);
                setSelectedRedeemRewardCardId('');
                setSelectedStorePINId('');
                setIsLoading(true);
              }}
            />
            <RewardUnlockSuccessDialog
              open={successUnlockedDialog}
              onClose={() => {
                setSuccessUnlockedDialog(false);
                setIsLoading(true);
              }}
            />
            {selectedSurvey &&
              openSurveyDialog &&
              selectedUnlockRewardCardId.length > 0 && (
                <SurveyDialog
                  companyId={merchant.id}
                  rewardId={selectedUnlockRewardCardId}
                  survey={selectedSurvey}
                  open={openSurveyDialog}
                  onClose={() => {
                    setSelectedSurvey(null);
                    setOpenSurveyDialog(false);
                  }}
                  confirmUnlock={(status: boolean) => {
                    if (status) {
                      setOpenSurveyDialog(false);
                      setSuccessUnlockedDialog(true);
                      setIsLoading(true);
                    }
                  }}
                  logo={merchant.logo!.versions.xl}
                />
              )}
            {profile && merchant && launchEditProfileDialog && (
              <EditProfileDialog
                open={launchEditProfileDialog}
                onClose={() => {
                  setLaunchEditProfileDialog(false);
                }}
                profile={profile}
                confirmUpdate={(status: boolean) => {
                  if (status) {
                    setLaunchEditProfileDialog(false);
                  }
                }}
                requestFullName={reqFullName}
                requestMobile={reqMobNum}
                requestEmail={reqEmail}
                requestAltEmail={reqAltEmail}
                requestDOB={reqDOB}
                requestCompany={reqCompany}
                logo={merchant.logo!.versions.xl}
              />
            )}
          </>
        )}
        <Dialog
          open={addToHomeScreenDialogOpen}
          onClose={() => setAddToHomeScreenDialogOpen(false)}
        >
          <DialogTitle>
            <InfoIcon style={{ marginRight: 8, verticalAlign: 'middle' }} />
            Add to Homescreen
          </DialogTitle>
          {device === 'iOS Device' && (
            <DialogContent>
              <div className={classes.dialogTextContainer}>
                <Typography variant="body1">1. Open Share menu</Typography>
                <SvgIcon component={ShareIcon} className={classes.icon} />
              </div>
              <div className={classes.dialogTextContainer}>
                <Typography variant="body1">
                  2. Tap on "Add to Home Screen" button
                </Typography>
                <AddBoxOutlinedIcon className={classes.icon} />
              </div>
            </DialogContent>
          )}
          {device === 'Android Device' && (
            <DialogContent>
              <div className={classes.dialogTextContainer}>
                <Typography variant="body1">1. Open Setting Menu</Typography>
                <MoreVertIcon className={classes.icon} />
              </div>
              <div className={classes.dialogTextContainer}>
                <Typography variant="body1">
                  2. Tap on "Add to Home Screen" button
                </Typography>
                <AddToHomeScreenIcon className={classes.icon} />
              </div>
            </DialogContent>
          )}
          <DialogActions>
            <Button
              onClick={() => setAddToHomeScreenDialogOpen(false)}
              color="primary"
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
        <AddToHomescreen
          onAddToHomescreenClick={() => setAddToHomeScreenDialogOpen(true)}
        />
      </div>
    </>
  );
}
